/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAlertedEntityType } from './ApiAlertedEntityType';
import {
    ApiAlertedEntityTypeFromJSON,
    ApiAlertedEntityTypeFromJSONTyped,
    ApiAlertedEntityTypeToJSON,
    ApiAlertedEntityTypeToJSONTyped,
} from './ApiAlertedEntityType';
import type { ApiPerson } from './ApiPerson';
import {
    ApiPersonFromJSON,
    ApiPersonFromJSONTyped,
    ApiPersonToJSON,
    ApiPersonToJSONTyped,
} from './ApiPerson';
import type { ApiTransaction } from './ApiTransaction';
import {
    ApiTransactionFromJSON,
    ApiTransactionFromJSONTyped,
    ApiTransactionToJSON,
    ApiTransactionToJSONTyped,
} from './ApiTransaction';

/**
 * 
 * @export
 * @interface ApiAlertedEntity
 */
export interface ApiAlertedEntity {
    /**
     * 
     * @type {number}
     * @memberof ApiAlertedEntity
     */
    id: number;
    /**
     * 
     * @type {ApiAlertedEntityType}
     * @memberof ApiAlertedEntity
     */
    entityType: ApiAlertedEntityType;
    /**
     * 
     * @type {ApiPerson}
     * @memberof ApiAlertedEntity
     */
    person?: ApiPerson;
    /**
     * 
     * @type {ApiTransaction}
     * @memberof ApiAlertedEntity
     */
    transaction?: ApiTransaction;
}



/**
 * Check if a given object implements the ApiAlertedEntity interface.
 */
export function instanceOfApiAlertedEntity(value: object): value is ApiAlertedEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function ApiAlertedEntityFromJSON(json: any): ApiAlertedEntity {
    return ApiAlertedEntityFromJSONTyped(json, false);
}

export function ApiAlertedEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAlertedEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityType': ApiAlertedEntityTypeFromJSON(json['entityType']),
        'person': json['person'] == null ? undefined : ApiPersonFromJSON(json['person']),
        'transaction': json['transaction'] == null ? undefined : ApiTransactionFromJSON(json['transaction']),
    };
}

export function ApiAlertedEntityToJSON(json: any): ApiAlertedEntity {
    return ApiAlertedEntityToJSONTyped(json, false);
}

export function ApiAlertedEntityToJSONTyped(value?: ApiAlertedEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityType': ApiAlertedEntityTypeToJSON(value['entityType']),
        'person': ApiPersonToJSON(value['person']),
        'transaction': ApiTransactionToJSON(value['transaction']),
    };
}

